<style src="./ModalCommands.scss" lang="scss"></style>
<template>
  <div class="modal-footer ModalCommands">
    <!-- Invalidar -->
    <div class="invalidCommand" v-if="validState === 0">
      <button
        type="button"
        v-shortkey="['del']"
        @shortkey="() => refuseValidation()"
        class="btn btn-danger"
        data-dismiss="modal"
        @click="refuseValidation"
      >
        Não Validar
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <button
      v-if="validState === 1 || validState === 2"
      v-shortkey="['esc']"
      @shortkey="() => cancelValidation()"
      type="button"
      class="btn btn-default"
      @click="cancelValidation"
    >
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
      Voltar
    </button>

    <div class="invalidCommand" v-if="validState === 2">
      <input type="text" v-model="invalidReason" class="form-control" placeholder="Motivo" ref="inputReason"/>
      <button
        type="button"
        v-shortkey="['del']"
        @shortkey="() => confirmRefuse()"
        class="btn btn-danger"
        data-dismiss="modal"
        @click="confirmRefuse"
        :disabled="isCommandsDisabled"
      >
        Confirmar Não Validar
        <i class="fa fa-times" aria-hidden="true"></i>
        <i class="fa fa-spinner fa-spin" v-show="isCommandsDisabled"></i>
      </button>
    </div>

    <!-- Validar -->
    <button
      v-if="validState === 0"
      v-shortkey="['enter']"
      @shortkey="() => setValidState(1)"
      type="button"
      class="btn btn-primary"
      @click="() => setValidState(1)"
    >
      Validar
      <i class="fa fa-arrow-right" aria-hidden="true"></i>
    </button>
    <button
      v-if="validState === 1"
      type="button"
      class="btn btn-success"
      @click="sendToSerpro"
      :disabled="isCommandsDisabled"
    >
      Confirmar e Enviar para SERPRO
      <i class="fa fa-check" aria-hidden="true"></i>
      <i class="fa fa-spinner fa-spin" v-show="isCommandsDisabled"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    totalDocuments: {
      default: false,
    },
    show: {
      default: false,
    },
  },
  data() {
    return {
      invalidReason: '',
      validState: 0,
      isCommandsDisabled: false,
    };
  },
  computed: {
    display() {
      return this.show ? 'display: block' : 'display: none';
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    async refuseValidation() {
      this.validState = 2;
      await this.$nextTick();
      this.$refs.inputReason.focus();
    },
    cancelValidation() {
      this.validState = 0;
    },
    setValidState(state) {
      this.validState = state;
    },
    confirmValidation() {
      this.validState = 0;
    },
    confirmRefuse() {
      this.isCommandsDisabled = true;
      this.$emit('refuse', this.invalidReason);
      this.resetCommands()
    },
    sendToSerpro() {
      this.isCommandsDisabled = true;
      this.$emit('send-to-serpro');
      this.resetCommands()
    },
    resetCommands() {
      this.isCommandsDisabled = false;
      this.validState = 0;
      this.invalidReason = '';
    },
    enableCommands() {
      this.isCommandsDisabled = false;
    }
  }
};
</script>
